import { Box, Divider, Text } from '@wix/design-system';
import { Check } from '@wix/wix-ui-icons-common/lazy';
import React from 'react';
import { isFeatureVisibleForCycle } from './isFeatureVisibleForCycle';
const LegacyFeaturesNamespace = _ref => {
  var _namespace$content, _namespace$features;
  let {
    namespace,
    productId,
    paymentCycle,
    t,
    Trans
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    marginBottom: "SP2"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "bold"
  }, t(((_namespace$content = namespace.content) == null || (_namespace$content = _namespace$content.name) == null ? void 0 : _namespace$content.translationKey) ?? '')), /*#__PURE__*/React.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "SP1"
  }, (_namespace$features = namespace.features) == null ? void 0 : _namespace$features.filter(feature => isFeatureVisibleForCycle(feature, productId, paymentCycle)).map(feature => {
    var _feature$content;
    return /*#__PURE__*/React.createElement(Box, {
      key: feature.id,
      verticalAlign: "middle",
      gap: "SP1"
    }, /*#__PURE__*/React.createElement(Check, null), /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: ((_feature$content = feature.content) == null || (_feature$content = _feature$content.name) == null ? void 0 : _feature$content.translationKey) ?? '',
      components: {
        ellipsis: /*#__PURE__*/React.createElement(React.Fragment, null)
      },
      values: {
        domainName: undefined
      }
    })));
  })));
};
export const LegacyPlanFeatures = _ref2 => {
  let {
    namespaces,
    productId,
    paymentCycle,
    t,
    Trans,
    dataHook
  } = _ref2;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    dataHook: dataHook
  }, namespaces == null ? void 0 : namespaces.filter(ns => {
    var _ns$features;
    return (_ns$features = ns.features) == null ? void 0 : _ns$features.some(feature => isFeatureVisibleForCycle(feature, productId, paymentCycle));
  }).map((ns, index, filtered) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: ns.id
  }, /*#__PURE__*/React.createElement(LegacyFeaturesNamespace, {
    namespace: ns,
    productId: productId,
    paymentCycle: paymentCycle,
    t: t,
    Trans: Trans
  }), index < filtered.length - 1 && /*#__PURE__*/React.createElement(Divider, {
    key: `divider-${index}`
  }))));
};
//# sourceMappingURL=LegacyPlanFeatures.js.map